import { Cotizacion, CotizacionItem } from "@/shared/types/cotizacion";
import { Moneda } from "@/shared/types/moneda";
import { Monto, MontoItem, MontoItemRequest, MontoRequest } from "@/shared/types/monto";
import { Transferencia, TransferenciaItem, TransferenciaItemRequest, TransferenciaRequest } from "@/shared/types/transferencia";

//Monedas
export function sortMonedas<T extends Partial<Moneda | CotizacionItem | MontoItem>>(monedas?: T[]): T[] {
    if (!monedas) return [] as unknown as T[];
    return [...monedas].sort((m1, m2) => m1.monedaBase ? -1 : m2.monedaBase ? 1 : 0) as T[];
}

export function getMonedaBase<T extends Partial<Moneda | CotizacionItem | MontoItem>>(monedas?: T[]): T | undefined {
    if (!monedas) return undefined;
    return monedas.find(m => m.monedaBase)
}

export function mapMonedaValues(cotizacion: Cotizacion, cantidadEnMoneda1: number, moneda1Id: string, moneda2Id: string) {
    const cotizacionMoneda1 = cotizacion.cotizacionItems.find(ci => ci.monedaId == moneda1Id)?.monedaBaseRelacion || 1;
    const cotizacionMoneda2 = cotizacion.cotizacionItems.find(ci => ci.monedaId == moneda2Id)?.monedaBaseRelacion || 1;

    const cantidadEnMonedaBase = cantidadEnMoneda1 * cotizacionMoneda1;
    const cantidadEnMoneda2 = cantidadEnMonedaBase / cotizacionMoneda2;

    return cantidadEnMoneda2;
}

//Monto
export function getMontoMonedaCantidad(monto: MontoRequest, monedaId: string) {
    return monto.items.filter(mi => mi.monedaId == monedaId).reduce((prev, curr) => prev + curr.cantidad, 0);
}

export function getMontoItem(monto: Monto | MontoRequest, monedaId: string): MontoItem | MontoItemRequest {
    return monto.items.find(mi => mi.monedaId == monedaId) || { monedaId: monedaId, cantidad: 0 };
}

export function getTotalMonto(monto: Monto | MontoRequest, cotizacion: Cotizacion, monedaAMostrarId?: string): number {
    const finalMonedaAMostrarId = monedaAMostrarId ? monedaAMostrarId : getMonedaBase(cotizacion.cotizacionItems)?.monedaId;
    if (!finalMonedaAMostrarId) throw new Error("Cotizacion Invalida");

    return monto.items.reduce((prev, curr) => prev + mapMonedaValues(cotizacion, curr.cantidad, curr.monedaId, finalMonedaAMostrarId), 0);
}

export function isMontoActive(monto: Monto | MontoRequest) {
    if (!monto) return false;
    for (const mi of monto.items) {
        if (mi.cantidad) return true;
    }
    return false;
}

//Transferencia
export function getTotalTransferencia(transferencia: Transferencia | TransferenciaRequest, cotizacion: Cotizacion, monedaAMostrarId?: string): number {
    return transferencia.items
        .filter(ti => isMontoActive(ti.monto))
        .reduce((prev, curr) => prev + getTotalMonto(curr.monto, cotizacion, monedaAMostrarId), 0)
}

export function getTotalMonedaTransferencia(transferencia: Transferencia | TransferenciaRequest, monedaId: string) {
    return transferencia.items
        .filter(ti => isMontoActive(ti.monto))
        .reduce((prev, curr) => prev + getMontoMonedaCantidad(curr.monto, monedaId), 0)
}

export function getTransferenciaItem(transferencia: Transferencia | TransferenciaRequest, metodoId: string): TransferenciaItem | TransferenciaItemRequest {
    return transferencia.items
        .filter(ti => isMontoActive(ti.monto))
        .find(ti => ti.transferenciaMetodoId == metodoId) || { transferenciaMetodoId: metodoId, monto: { items: [] } };
}

export function isTransferenciaActive(transferencia: Transferencia | TransferenciaRequest) {
    if (!transferencia) return false;
    for (const ti of transferencia.items) {
        if (isMontoActive(ti.monto)) return true;
    }

    return false;
}

export function getTransferenciaMetodoMonedaCantidad(transferencia: Transferencia | TransferenciaRequest, metodoId: string, monedaId: string) {
    return transferencia.items
        .filter(ti => isMontoActive(ti.monto))
        .find(ti => ti.transferenciaMetodoId == metodoId)?.monto.items
        .find(mi => mi.monedaId == monedaId)?.cantidad || 0;
}